export const DATA_FILTER_GAME: any = {
  events: 'Event',
  event: 'Event',
  sales: 'Sale',
  sale: 'Sale',
  updates: 'Game update',
  update: 'Game update',
  'game update': 'Game update',
  'game updates': 'Game update',
  game: 'Game update',
  company: 'Company',
  done: 'Done',
  download: 'Downloads',
  downloads: 'Downloads',
  new: 'New game',
  news: 'New game',
  'new game': 'New game',
  upcoming: 'Upcoming game',
  'upcoming game': 'Upcoming game',
  announcement: 'Announcement',
  'members only': 'Members only',
  'patch notes': 'Patch notes',
  'patch note': 'Patch notes',
  trailer: 'Trailer',
  trailers: 'Trailer',
  'tips and tricks': 'Tips and tricks',
  dlc: 'DLC',
};
